export const CDN_URL = {
    STATE: 'statemaster.json',
    DISTRICT: 'state',
    BLOCK: 'blockmaster.json',
    PANCHAYAT: 'panchayatmaster.json',
    VILLAGE: 'villagemaster.json'
};
